// get context url based on client code
export function getContextUrl(clientCode: string) {
    if (clientCode === "admin") {
      return import.meta.env.VITE_CONTEXT_URL_FOR_ADMIN;
    }
    return import.meta.env.VITE_CONTEXT_URL_FOR_CLIENT;
}

// Converts epoch (seconds or ms) to a readable string (default: 'YYYY-MM-DD HH:mm:ss')
export function epochToDateTime(epoch: number | string, withTime = true): string {
  if (!epoch) return '';
  // If epoch is in seconds, convert to ms
  const ms = String(epoch).length === 10 ? Number(epoch) * 1000 : Number(epoch);
  const date = new Date(ms);
  if (isNaN(date.getTime())) return '';
  // Format: YYYY-MM-DD HH:mm:ss
  const pad = (n: number) => n.toString().padStart(2, '0');
  const y = date.getFullYear();
  const m = pad(date.getMonth() + 1);
  const d = pad(date.getDate());
  if (!withTime) return `${y}-${m}-${d}`;
  const h = pad(date.getHours());
  const min = pad(date.getMinutes());
  const s = pad(date.getSeconds());
  return `${y}-${m}-${d} ${h}:${min}:${s}`;
}

// Converts a JS Date or date string to epoch (seconds)
export function dateTimeToEpoch(date: Date | string): number {
  if (!date) return 0;
  const d = typeof date === 'string' ? new Date(date) : date;
  return Math.floor(d.getTime() / 1000);
}